import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cfilter'
})
export class CfilterPipe implements PipeTransform {

  transform(items: any[], termm: any): any[] {
    if(!items) return [];
    if(!termm) return items;
    termm = termm.toString().toLowerCase();
    return items.filter( it => {
      return it.model.toString().toLowerCase().includes(termm);
    });
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/cfilter.pipe.ts